import ls from './tools/ls.js';

export default {
  namespaced: true,
  state: {
    token: ls.init('token', String, null),
    ok: 0,
  },
  mutations: {
    token(state, token) {
      ls.set('token', token);
      if (!token) ls.clear('token');
      state.token = token;
    },
    ok(state, ok) {
      state.ok = ok;
    },
  },
};
